<template>
    <div
        class="card-container"
        v-loading="loading"
        element-loading-text="拼命加载中..."
        element-loading-spinner="el-icon-loading"
    >
        <common-top-form
            ref="commonTopForm"
            selectShowPower="/personaluser/select"
            :model="formModel"
            @success="onSuccess"
            :submitService="submitService"
            :submitData="submitData"
        >
            <el-form-item label="用户ID">
                <el-input
                    type="text"
                    maxlength="11"
                    v-model="formModel.userId"
                    placeholder="请输入手机号"
                ></el-input>
            </el-form-item>
            <el-form-item label="手机号">
                <el-input
                    type="text"
                    maxlength="11"
                    v-model="formModel.phoneNumber"
                    placeholder="请输入手机号"
                ></el-input>
            </el-form-item>
            <el-form-item label="性别">
                <el-select v-model="formModel.gender" clearable placeholder="请选择">
                    <el-option
                        v-for="item in gender"
                        :key="item.id"
                        :label="item.value"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="创建时间">
                <el-date-picker
                    v-model="formModel.time"
                    type="daterange"
                    range-separator="至"
                    :clearable="true"
                    value-format="yyyy-MM-dd"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                >
                </el-date-picker>
            </el-form-item>
        </common-top-form>
        <common-table
            :data="tableData"
            ref="commonTable"
            @handleChange="getPage"
        >
            <el-table-column
                prop="id"
                label="ID"
                min-width="150"
                show-overflow-tooltip
                :formatter="formatterTableData"
            ></el-table-column>
            <el-table-column prop="phoneNumber" label="手机号" min-width="130">
                <template slot-scope="scope">
          <span
              class="blue-text table-text-button"
              @click.self="updateInfo(scope.row.id)"
              v-if="hasPerm('/meminfo/selectOneByTatId')"
          >{{ scope.row.phoneNumber }}</span
          >
                    <span v-else>{{ scope.row.phoneNumber }}</span>
                </template>
            </el-table-column>
            <el-table-column
                prop="nickName"
                label="昵称"
                min-width="150"
                show-overflow-tooltip
                :formatter="formatterTableData"
            ></el-table-column>
            <el-table-column
                prop="gender"
                label="性别"
                min-width="100"
                show-overflow-tooltip
                :formatter="formatterTableGender"
            ></el-table-column>
            <el-table-column
                prop="memStatus"
                label="状态"
                min-width="100"
                show-overflow-tooltip
                :formatter="formatterEnable"
            ></el-table-column>
            <el-table-column
                prop="weComFlag"
                label="企微会员"
                min-width="100"
                show-overflow-tooltip
            >
                <template slot-scope="scope">
                    <el-switch
                        v-model="scope.row.weComFlag"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-value="1"
                        inactive-value="0"
                        @change="statusweComFlag($event, scope.row)"
                    />
                </template>
            </el-table-column>
            <el-table-column
                prop="createTime"
                label="创建时间"
                min-width="160"
                :formatter="formatterTableData"
            ></el-table-column>
            <el-table-column
                fixed="right"
                label="操作"
                min-width="180"
                v-if="hasPerm('/personaluser/status')">
                <template slot-scope="scope">
                    <el-button
                        type="text"
                        @click="handleStatus(scope.row)"
                    >{{scope.row.memStatus == 1 ? '禁用' : '启用'}}
                    </el-button>
                </template>
            </el-table-column>
        </common-table>
    </div>
</template>

<script>
    import CommonTopForm from "components/common/CommonTopForm";
    import CommonTable from "components/common/CommonTable";
    import SelectOrgans from "components/business/SelectOrgans";
    import FormDialog from "../../dialog/FormDialog";

    import OrganService from "service/OrganService";
    import TimeRange from "service/constant/TimeRange";
    import Regs from "common/conf/Regs";
    import MonthNum from "service/constant/MonthNum";
    import DayNum from "service/constant/DayNum";
    import StatisticsService from "service/StatisticsService";
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin} from "mixin";
    import {mapGetters, mapActions} from "vuex";
    import StorageService from "store/interfaces";

    export default {
        name: "personaluser",
        data() {
            return {
                formModel: {
                    userId: '',
                    phoneNumber: '',
                    gender: "",
                    time: "",
                },
                gender: [
                    {
                        id: '',
                        value: "全部",
                    },
                    {
                        id: 'M',
                        value: "男",
                    },
                    {
                        id: 'F',
                        value: "女",
                    },
                ],
                tableData: [],
                submitService: OrganService.privateMemList,
                page: {},
                memInfo: {},
                isPage: false,
                loading: false,
            };
        },
        components: {
            SelectOrgans,
            CommonTopForm,
            CommonTable,
            FormDialog,
        },
        mounted() {
            this.page = this.$refs.commonTable.page;
            this.getList();
        },
        mixins: [loadMixin, dialogMixin],
        computed: {
            submitData() {
                if (this.formModel.time == null || this.formModel.time == "") {
                    this.formModel.time = [];
                }
                const params = {

                    id: this.formModel.userId,
                    phoneNumber: this.formModel.phoneNumber,
                    gender: this.formModel.gender,
                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };
                if (this.formModel.time.length) {
                    params.startDate = this.formModel.time[0];
                    params.endDate = this.formModel.time[1];
                }
                return params;
            },
            ...mapGetters([
                "serverType",
                "tatId",
                "userId",
                "userInfo",
                "basicInfoFlag",
            ]),
        },
        watch: {},
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                if (from.path.indexOf("personalbasicinfo") > -1 || vm.basicInfoFlag) {
                    vm.$refs.commonTopForm.submit();
                }
            });
        },
        methods: {
            updateInfo(id) {
                this.$router.push({
                    name: "personalbasicinfo",
                    params: {
                        id: id,
                    },
                });
            },
            getPage() {
                this.isPage = true;
                this.getList();
            },
            getList() {
                this.doLoad(
                    OrganService.privateMemList, this.submitData,
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.onSuccess(res);
                            this.isPage = false;
                        });
                    },
                    "信息获取失败"
                );
            },
            onSuccess(data) {
                this.doCheck(data, (res) => {
                    this.loading = false;
                    const result = res.contents;
                    this.tableData = result.rows;

                    this.page.currentPage = result.current;
                    this.page.pageSize = result.size;
                    this.page.total = result.total;
                    this.setBasicInfoFlag(false);
                });
            },
            handleStatus(item){
                this.showConfirm("是否" + (item.memStatus == 1 ? '禁用' : '启用') +"？")
                    .then(() => {
                        this.doStatus(item.id, item.memStatus == 1 ? '0' : '1');
                    })
                    .catch(() => {
                    });
            },
            commonSuccess(res) {
                this.showSuccess(res.respMsg);
                this.getList();
            },
            doStatus(id, status) {
                this.doLoad(
                    OrganService.privateMemudpStatus,
                    {
                        id: id,
                        memStatus: status
                    },
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.commonSuccess(res);
                        });
                    },
                    "操作失败"
                );
            },
            formatterTableGender(row, column, cellValue, index) {
                let value = "";
                this.gender.forEach((item) => {
                    if (item.id == cellValue) {
                        value = item.value;
                    }
                });
                return value == '' ? '--' : value;
            },
            ...mapActions({
                setBasicInfoFlag: StorageService.Reload.basicInfoFlag,
            }),
            statusweComFlag($event, scope) {
                this.doweComFlag($event, scope);
            },
            doweComFlag($event, scope) {
                this.doLoad(
                    OrganService.privateMemudpStatus,
                    {
                        weComFlag: $event,
                        id: scope.id,
                    },
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.commonSuccess(res);
                        });
                    },
                    "操作失败"
                );
            },
        },
    };
</script>

<style scoped>
    .parent-box {
        margin-bottom: 20px;
    }

    .tat-title {
        margin-bottom: 20px;
        vertical-align: middle;
        line-height: 40px;
        color: rgba(170, 170, 170, 1);
    }

    .tat-title span {
        display: inline-block;
        width: 90px;
        text-align: right;
        vertical-align: middle;
        font-size: 14px;
        color: #606266;
        line-height: 40px;
    }
</style>



// WEBPACK FOOTER //
// src/view/page/OrganizationManage/PersonalUser.vue